import axios from 'axios';
import { baseUrl } from '@/config';
import forEach from 'lodash/forEach';

export default {
  /**
   * 보고서 트리 조회
   * @author kimjy
   */
  getReportTreeData() {
    return axios.get(`${baseUrl}/report/get-report-tree-data.do`);
  },
  /**
   * 보고서 클릭 시 보고서 데이터 조회
   * @author kimjy
   */
  getReportInstData(params) {
    return axios.get(`${baseUrl}/report/get-report-inst-data.do`, { params });
  },
  /**
   * 보고서 출력
   * @author kimjy
   */
  generateReport(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/report/generate-report.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    if (params.reportTmplType === 'OZ') {
      window.open('', 'ozreport');
      form.target = 'ozreport';
    }
    form.submit();
    document.body.removeChild(form);
  },
  /**
   * 보고서 관리 그룹 컴포넌트 데이터 조회
   * @author kimjy
   */
  getWatchallGroupList() {
    return axios.get(`${baseUrl}/report/get-watchall-group-list.do`);
  },
  /**
   * 보고서 성능 지표 컴포넌트 데이터 조회
   * @author kimjy
   */
  getRscInfoList(params) {
    return axios.post(`${baseUrl}/report/get-watchall-rsc-list.do`, params);
  },
  /**
   * 보고서 추가
   * @author kimjy
   */
  addReport(params) {
    return axios.post(`${baseUrl}/report/add-report.do`, params);
  },
  /**
   * 보고서 템플릿에 해당하는 보고서 리스트를 조회한다
   * @author kimjy
   * @param  {Object} params reportTmplId, orderType, searchValue
   */
  gerReportList(params) {
    return axios.post(`${baseUrl}/report/get-report-list.do`, params);
  },
  /**
   * 보고서 수정
   * @author kimjy
   */
  updateReport(params) {
    return axios.post(`${baseUrl}/report/update-report.do`, params);
  },
  /**
   * 보고서 삭제
   * @author kimjy
   */
  deleteReport(params) {
    return axios.post(`${baseUrl}/report/delete-report.do`, params);
  },
  getReportHist(params) {
    return axios.post(`${baseUrl}/report/get-report-hist.do`, params);
  },
  existsReport(params) {
    return axios.post(`${baseUrl}/report/exists-report.do`, params);
  },
  downloadReport(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/report/download-report.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },
  downloadLastGeneratedReport(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/report/download-last-generated-report.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    if (params.reportTmplType === 'OZ') {
      window.open('', 'ozreport');
      form.target = 'ozreport';
    }
    form.submit();
    document.body.removeChild(form);
  },
  getMaintenanceHist(params) {
    return axios.post(`${baseUrl}/report/get-maintenance-hist.do`, params);
  },
  getMaintenanceSummary(params) {
    return axios.post(`${baseUrl}/report/get-maintenance-summary.do`, params);
  },
  updateMaintenanceHist(params) {
    return axios.post(`${baseUrl}/report/update-maintenance-hist.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/report/report.js